import { Action, createReducer, on } from '@ngrx/store';

import * as EditInfoActions from './edit-info.actions';

export const EDIT_INFO_FEATURE_KEY = 'editInfo';

export interface EditInfoState {
  saving: boolean; // has the EditInfo list been loaded
  error?: string | null; // last known error (if any)
}

export const initialEditInfoState: EditInfoState = {
  // set initial required properties
  saving: false,
};

const reducer = createReducer(
  initialEditInfoState,
  on(EditInfoActions.openEditInfoDialog, () => ({
    ...initialEditInfoState,
  })),
  on(EditInfoActions.saveEditInfo, (state) => ({
    ...state,
    saving: true,
    error: null,
  })),
  on(EditInfoActions.saveEditInfoSuccess, (state) => ({
    ...state,
    saving: false,
  })),
  on(EditInfoActions.saveEditInfoFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  })),
);

export function editInfoReducer(
  state: EditInfoState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
